// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d82b3e36","69":"f9196485","421":"014b889d","422":"d71c4f31","588":"016c2957","675":"70df5842","679":"e019c058","711":"44dae16d","726":"ea4f3cb4","791":"8a22cb45","926":"f6bfb57d"}[chunkId] + ".chunk.js";
};